import * as React from "react";
import { Link } from "react-router-dom";
import actionTypes from "../../../../actions/ActionTypes";
import { GetScheduleList } from "../../../../actions/ScheduleActions";
import ScheduleStore from "../../../../stores/ScheduleStore";
class ScheduleSidebar extends React.Component {
  constructor() {
    super();
    this.state = {
      searchText: "",
      filteredSchedules: [],
      showInactive: false,
      maxHeight: window.innerHeight - 350
    };
    this.onReceiveScheduleChange = this.onReceiveScheduleChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.changeShowInactive = this.changeShowInactive.bind(this);
  }
  componentDidMount() {
    ScheduleStore.addChangeListener(this.onReceiveScheduleChange);
    GetScheduleList();
  }
  componentWillUnmount() {
    ScheduleStore.removeChangeListener(this.onReceiveScheduleChange);
  }
  onReceiveScheduleChange() {
    var lastChange = ScheduleStore.getLastChange();
    if (lastChange === actionTypes.SchedulesGetList) {
      var schedList = ScheduleStore.getScheduleList();
      var filter = [...schedList];
      this.setState({ scheduleList: schedList, filteredSchedules: filter });
    }
    if (lastChange === actionTypes.ScheduleUpdateOne) {
      GetScheduleList();
    }
  }
  changeShowInactive(e) {
    let showInactive = e.target.checked;
    if (showInactive) {
    } else {
    }
    this.setState({ showInactive });
  }
  onSearchChange(e) {
    let search = e.target.value;
    if (search === "") {
      let newList = [...this.state.scheduleList];
      this.setState({ searchText: search, filteredSchedules: newList });
    } else {
      let newList = [];
      this.state.scheduleList.forEach((formType) => {
        if (formType.name.toLowerCase().includes(search.toLowerCase())) {
          newList.push(formType);
        }
      });
      this.setState({ searchText: search, filteredSchedules: newList });
    }
  }
  render() {
    let listOfScheds;
    if (this.state.filteredSchedules !== void 0) {
      listOfScheds = this.state.filteredSchedules.map((schedule) => /* @__PURE__ */ React.createElement("span", null, (schedule.isActive === true || this.state.showInactive === true) && /* @__PURE__ */ React.createElement("div", { key: schedule.id }, schedule.isActive === false && /* @__PURE__ */ React.createElement("span", { className: "me-2", style: { color: "#B7E4EA" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-lock" })), schedule.jobType === 1 && /* @__PURE__ */ React.createElement("span", { className: "me-2", style: { color: "#B7E4EA" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-calendar-check" })), schedule.jobType === 2 && /* @__PURE__ */ React.createElement("span", { className: "me-2", style: { color: "#B7E4EA" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-envelope-circle-check" })), schedule.jobType === 5 && /* @__PURE__ */ React.createElement("span", { className: "me-2", style: { color: "#B7E4EA" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-magnifying-glass-plus" })), schedule.jobType === 6 && /* @__PURE__ */ React.createElement("span", { className: "me-2", style: { color: "#B7E4EA" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-duotone fa-regular fa-broom-wide" })), schedule.jobType === 7 && /* @__PURE__ */ React.createElement("span", { className: "me-2", style: { color: "#B7E4EA" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-brain-circuit" })), /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/Schedule/" + schedule.id }, schedule.name))));
    } else {
      listOfScheds = /* @__PURE__ */ React.createElement("div", null);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "350px" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          to: "/Admin/Schedules",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("span", { style: { color: "#6CE84E" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-calendar-check" })), "   ", "Schedules")
      ),
      " ",
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { className: "input-group rounded", style: { marginBottom: "16px" } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "search",
          value: this.state.searchText,
          className: "form-control",
          placeholder: "Search",
          "aria-label": "Search",
          onChange: this.onSearchChange,
          "aria-describedby": "search-addon"
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "input-group-text border-0", id: "search-addon" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-search" }))),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          className: "form-check-input",
          checked: this.state.showInactive,
          onChange: this.changeShowInactive,
          id: "chkActive"
        }
      ), /* @__PURE__ */ React.createElement(
        "label",
        {
          className: "form-check-label",
          style: { fontSize: "8pt" },
          htmlFor: "chkActive"
        },
        "Show Inactive"
      )),
      /* @__PURE__ */ React.createElement("div", { className: "coolScroll", style: { maxHeight: `${this.state.maxHeight}px`, overflowY: "auto" } }, listOfScheds),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/Schedule/0" }, "New Schedule")
    );
  }
}
export default ScheduleSidebar;
